import { SectionHeader } from '@/components/ui/section-header';
import { PageContainer } from '@/components/ui/page-container';
import { cn } from '@/lib/utils';

interface PageLayoutProps {
  children: React.ReactNode;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
    variant?: 'default' | 'secondary' | 'outline';
  };
  headerChildren?: React.ReactNode;
  className?: string;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full';
}

export function PageLayout({
  children,
  title,
  description,
  action,
  headerChildren,
  className,
  maxWidth = 'full',
}: PageLayoutProps) {
  return (
    <PageContainer maxWidth={maxWidth} className={cn('space-y-6', className)}>
      <SectionHeader title={title} description={description} action={action}>
        {headerChildren}
      </SectionHeader>

      <div className="space-y-6">{children}</div>
    </PageContainer>
  );
}
